import { useEffect } from 'react';
import {
    Card, Table, TableBody, TableCell, Container, TableContainer, TableRow, Button
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Page from './../../components/Page';
import Scrollbar from './../../components/Scrollbar';
import { UserListHead } from '../../sections/@dashboard/user';
import HeaderBreadcrumbs from './../../components/HeaderBreadcrumbs';
import { toast } from 'react-toastify';
import Loader from 'src/components/Loader';
import moment from 'moment';
import { GetStateListAction, ResetUpdateStateStatusAction, UpdateStateStatusAction } from 'src/redux/actions/StateAction';
import "./../BannerManagement/BannerManagement.css"

export default function StateManager() {
    const dispatch = useDispatch();
    const stateApiData = useSelector(state => state.states.state_list.data)
    const loadingSelector = useSelector(state => state.states.loading)
    const updateSelector = useSelector(state => state.states.state_updated)

    useEffect(() => {
        dispatch(GetStateListAction())
    }, [dispatch])

    useEffect(() => {
        if (Object.keys(updateSelector).length > 0) {
            if (updateSelector.status) {
                toast.success(updateSelector.data.message, { theme: "colored" })
                dispatch(ResetUpdateStateStatusAction())
                dispatch(GetStateListAction())
            }
        }
    }, [updateSelector])

    const handleStateStatus = (value) => {
        console.log("value.status", value.status)
        let data = {
            ...value,
            status: value.status === 1 ? 2 : 1
        }
        dispatch(UpdateStateStatusAction(data))
    }

    return (
        <Page title="Cricket Teams Manager">
            {loadingSelector ? <Loader /> : null}

            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="State Management"
                    links={[
                        { name: 'Dashboard', href: "/dashboard/app" },
                        { name: 'State Management' }
                    ]}
                />

                <Card>
                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                                <UserListHead
                                    headLabel={[
                                        { id: "c_no", label: "Sr no.", alignRight: false },
                                        { id: 'name', label: 'State Name', alignRight: false },
                                        { id: 'status', label: 'Status', alignRight: false },
                                        { id: 'created', label: 'Created', alignRight: false }
                                    ]}
                                />
                                <TableBody>
                                    {stateApiData &&
                                        stateApiData.data.state_list.sort((a, b) =>
                                            a.name < b.name ? -1 : 1
                                        ).map((value, index) => {
                                            return (
                                                <TableRow hover key={index}>
                                                    <TableCell component="th" scope="row">
                                                        {index + 1}.
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">{value.name ? value.name : "-"}</TableCell>
                                                    <TableCell component="th" scope="row">
                                                        <Button onClick={() => handleStateStatus(value)}>
                                                            {value.status === 1 ?
                                                                <span className='badge badge-small badge-success'>active</span>
                                                                :
                                                                <span className='badge badge-small badge-error'>deactive</span>
                                                            }
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        {value?.updatedAt ? moment(value.updatedAt).format("DD-MM-YYYY") : "-"}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>
                </Card>
            </Container>
        </Page>
    );
}
